module.exports = __webpack_public_path__ + "img/notification-icon-dark-mode.0ce2891.svg";